export default __webpack_public_path__ + "static/media/blurredGreen.1a1d867e.png";